module.exports = {
  title: 'Image',
  context: {
    image: '@image'
  }
}
